var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import mtzService from "@/core/services/mtzService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Treinamento_ColaboradorActions } from "@/store/enums/mtzEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Treinamento_ColaboradorModule = class Treinamento_ColaboradorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Treinamento_ColaboradorActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            mtzService.getFile("Treinamento_Colaborador/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Treinamento_Colaborador.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Treinamento_ColaboradorActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            mtzService.postFile("Treinamento_Colaborador/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Treinamento_ColaboradorActions.POST_TREINAMENTO_COLABORADOR](data) {
        return new Promise(resolve => {
            mtzService.post("Treinamento_Colaborador/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Treinamento_ColaboradorActions.PUT_TREINAMENTO_COLABORADOR](data) {
        return new Promise(resolve => {
            mtzService.put("Treinamento_Colaborador/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Treinamento_ColaboradorActions.DELETE_TREINAMENTO_COLABORADOR](data) {
        return new Promise(resolve => {
            mtzService.delete("Treinamento_Colaborador/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Treinamento_ColaboradorActions.DELETE_RANGE_TREINAMENTO_COLABORADOR](data) {
        return new Promise(resolve => {
            mtzService.delete("Treinamento_Colaborador/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Treinamento_ColaboradorActions.FILTER_TREINAMENTO_COLABORADOR](data) {
        return new Promise(resolve => {
            mtzService.post("Treinamento_Colaborador/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Treinamento_ColaboradorActions.GET_TREINAMENTO_COLABORADOR]() {
        return new Promise(resolve => {
            mtzService.get("Treinamento_Colaborador/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Treinamento_ColaboradorActions.GETWITHDISABLED_TREINAMENTO_COLABORADOR]() {
        return new Promise(resolve => {
            mtzService.get("Treinamento_Colaborador/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Treinamento_ColaboradorActions.GET_BY_ID_TREINAMENTO_COLABORADOR](data) {
        return new Promise(resolve => {
            mtzService.get("Treinamento_Colaborador/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Treinamento_ColaboradorModule.prototype, _k, null);
Treinamento_ColaboradorModule = __decorate([
    Module
], Treinamento_ColaboradorModule);
export default Treinamento_ColaboradorModule;
//# sourceMappingURL=Treinamento_ColaboradorModule.js.map